// filtrování v rámci projektů
// JS: https://isotope.metafizzy.co/
// zdroj: https://codepen.io/aylinmarie/pen/NjwOGv
function referencesFilter() {
  $('.reference-grid').isotope({
    itemSelector: '.reference-item',
  });

  // filter items on button click
  $('.reference-filter__item').on('click', function () {
    var filterValue = $(this).attr('data-filter');
    $('.reference-grid').isotope({ filter: filterValue });
    $('.reference-filter__item').removeClass('is-active');
    $(this).addClass('is-active');
    AOS.refresh();
  });
}
